// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"6faa775f","498":"d9d0b0df","703":"fde8112d"}[chunkId] + ".chunk.js";
};